export default {"src":"/_next/static/media/qshop_long_logo.f2cd17b8.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};